import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const categoryIcons: Record<string, string> = {
  'Shoes': 'ri-footprint-line',
  'Hoodies / Sweaters': 'ri-t-shirt-line',
  'T-Shirts': 'ri-t-shirt-air-line',
  'Jackets': 'ri-shirt-line',
  'Pants / Shorts': 'ri-user-line',
  'Headwear': 'ri-user-6-line',
  'Sets': 'ri-stack-line',
  'Underwear / Underpants': 'ri-shirt-line',
  'Jersey': 'ri-team-line',
  'Accessories': 'ri-glasses-line',
  'Bags': 'ri-briefcase-4-line',
  'Belts': 'ri-link-m',
  'Perfumes': 'ri-drop-line',
  'Other Stuff': 'ri-more-line',
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setMobileCatOpen(false);
    setDropdownOpen(false);
  }, [location]);

  const isLight = !scrolled && isHomePage;

  const logoTextClass = isLight ? 'text-background-50' : 'text-foreground-900';
  const navLinkClass = isLight
    ? 'text-background-50/85 hover:text-background-50'
    : 'text-foreground-700 hover:text-primary-500';
  const hamburgerClass = isLight ? 'text-background-50' : 'text-foreground-900';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className={`ri-database-2-line text-2xl ${isLight ? 'text-background-50' : 'text-primary-500'}`}></i>
            </div>
            <span className={`font-heading text-lg font-semibold whitespace-nowrap transition-colors duration-300 ${logoTextClass}`}>
              Basetao Sheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-5">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${navLinkClass}`}
            >
              Home
            </Link>

            <Link
              to="/shopping-guide"
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${navLinkClass}`}
            >
              Shopping Guide
            </Link>

            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Browse Categories</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
                </div>
              </button>

              {dropdownOpen && (
                <>
                  <div
                    className="fixed inset-0 z-40"
                    onClick={() => setDropdownOpen(false)}
                  />
                  <div className="absolute top-full right-0 mt-2 w-72 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden z-50 shadow-lg">
                    <div className="max-h-96 overflow-y-auto py-2">
                      {categories.map((cat) => (
                        <a
                          key={cat.name}
                          href={cat.url}
                          target="_blank"
                          rel="noopener nofollow"
                          onClick={() => setDropdownOpen(false)}
                          className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors"
                        >
                          <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                            <i className={`${categoryIcons[cat.name] || 'ri-store-2-line'} text-xs text-primary-600`}></i>
                          </div>
                          {cat.name}
                        </a>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-5 py-2 rounded-lg bg-foreground-900 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              isLight ? 'hover:bg-background-50/20' : 'hover:bg-background-100'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`text-xl transition-colors duration-300 ${hamburgerClass} ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-4 space-y-1">
            <div className="flex items-center gap-2 mb-4">
              <Link
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className="flex-1 px-4 py-3 rounded-lg bg-primary-100 text-primary-700 text-sm font-semibold text-center hover:bg-primary-200 transition-colors"
              >
                <i className="ri-home-4-line mr-1.5"></i>
                Home
              </Link>
              <Link
                to="/shopping-guide"
                onClick={() => setMobileMenuOpen(false)}
                className="flex-1 px-4 py-3 rounded-lg bg-accent-100 text-accent-700 text-sm font-semibold text-center hover:bg-accent-200 transition-colors"
              >
                <i className="ri-book-open-line mr-1.5"></i>
                Shopping Guide
              </Link>
            </div>

            <div className="border-t border-background-200/70 pt-3">
              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="w-full flex items-center justify-between px-3 py-2.5 text-sm font-semibold text-foreground-900"
              >
                <span className="flex items-center gap-2">
                  <i className="ri-grid-line text-primary-500"></i>
                  Browse Categories
                </span>
                <div className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line"></i>
                </div>
              </button>

              {mobileCatOpen && (
                <div className="mt-1 grid grid-cols-2 gap-1 px-1">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileMenuOpen(false)}
                      className="flex items-center gap-2 px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 rounded-lg transition-colors"
                    >
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                        <i className={`${categoryIcons[cat.name] || 'ri-store-2-line'} text-[10px] text-primary-600`}></i>
                      </div>
                      <span className="truncate">{cat.name}</span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div className="border-t border-background-200/70 pt-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileMenuOpen(false)}
                className="block px-4 py-3 rounded-lg bg-foreground-900 text-background-50 text-sm font-semibold text-center hover:bg-foreground-800 transition-colors"
              >
                <i className="ri-shopping-cart-2-line mr-1.5"></i>
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}